<template>
 <div class="SideNav">
  <div id="sideBarBackground" @click="closeSideBar">
   <div class="sideBar" @mouseover="mouseOver" @mouseleave="mouseLeave">
    <div class="sideBar-logo-section" @click="goToDashboard()">
     <img src="../assets/images/logo/logo1.png" class="stockants-logo" />
     <!-- <img :style="[
            currentEnvironment.width ? { width: currentEnvironment.width } : {},
          ]" :src="currentEnvironment.logo" class="cursor-pointer navbar-logo broker-logo" /> -->
    </div>

    <!-- v-if="checkEligiblity" -->
    <div class="profile-section top-margin-10 bottom-margin-10 flex-space-between">
     <div class="flex">
      <div class="relative">
       <img :src="profile_pic" v-if="userProfile.picture" class="sideNav-profile-pic" />

       <img src="../assets/images/navBar/avatar.jpg" v-else class="sideNav-profile-pic" />

       <div class="rank-wrapper" v-if="user_details.rank">
        <Hexagon :rank="user_details.rank"></Hexagon>
       </div>
      </div>

      <div class="profile-details-section left-margin-10 cursor-pointer" @click="userProfile.source != 'Angelone' ? goToLink('/profile-update') : ''" style="word-wrap: break-word; width: 160px">
       <div class="font-07rem font-weight-600 capitalize" v-if="userProfile.full_name">
        {{ userProfile.full_name }}
        <span>
         <el-tooltip v-if="userProfile.mark_as_verified_user" class="item" effect="dark" content="Verified SEBI registered Expert" placement="top">
          <img class="info-Logo" src="../assets/images/verify.svg" style="width: 16px; position: relative; top: 3px" alt />
         </el-tooltip>
        </span>
       </div>

       <div class="font-07rem font-weight-600 top-margin-10" v-else-if="!userProfile.full_name && userProfile.email">
        {{ userProfile.email }}
       </div>

       <div class="input-label-gray top-margin-5" style="font-size: 11px">
        {{ userProfile.profession }}
       </div>
      </div>
     </div>

     <div class="cursor-pointer" @click="userProfile.source != 'Angelone' ? goToLink('/profile-update') : ''">
      <i class="el-icon-arrow-right"></i>
     </div>
    </div>

    <div class="sideBar-menu-section">
     <div
      class="menu-item"
      :class="{
       'active-menu-item': $route.path == '/retail-investors',
      }"
      @click="goToLink('/retail-investors')"
     >
      Home
     </div>

     <div v-if="websiteUserType.userSubType != 'brokerWithoutPlans' && currentEnvironment.loginModule != 'BlinkX'" class="menu-item flex-space-between" :class="{ 'active-menu-item': $route.path == '/pricing' }">
      <div @click="goToLink('/pricing')">Plans</div>

      <div class="go-premium-btn" v-if="getSubscribedPlanDetails && getSubscribedPlanDetails.plan != 'Premium'" @click="checkSubscribePlanDetails()">Go Premium</div>

      <div class="go-premium-btn" v-else @click="goToLink('/my-account')">Plan details</div>
     </div>
     <div v-if="websiteUserType.userSubType == 'brokerWithoutPlans'">
      <div class="menu-item" :class="{ 'active-menu-item': $route.path == '/my-account' }" @click="goToLink('/my-account')">My Account</div>
     </div>
     <!-- <div class="menu-item" :class="{ 'active-menu-item': $route.path == '/expert-list' }" v-on:click="goToLink('/expert-list')
            ">
            Expert Chat
          </div> -->

     <div @click="goToLink('/dashboard')" class="menu-item" style="border-bottom: 1px solid #e4e6ec" :class="{ 'active-menu-item': $route.path == '/dashboard' }" v-if="userProfile && isAdmin">
      <div>StockAnts Performers</div>
     </div>

     <el-collapse class="menu-item" accordion v-model="toggleSideMenu" v-if="userProfile && userProfile.profession != 'Retail Investor' && websiteUserType.userType != 'broker'" style="border-top: 1px solid #e4e6ec !important">
      <el-collapse-item name="3">
       <template slot="title">
        <div>My board</div>
       </template>

       <div
        @click="goToLink('/my-dashboard')"
        v-if="selectedMarketType == 'equity'"
        class="sub-menu-item"
        :class="{
         'active-menu-item': $route.path == '/my-dashboard',
        }"
       >
        <div>
         {{ userProfile && userProfile.first_name ? userProfile.first_name + "'s" : 'My' }}
         Portfolio
        </div>
       </div>

       <div
        @click="goToLink('/stockants-dashboard-analytics')"
        v-if="isAdmin && selectedMarketType == 'equity'"
        class="sub-menu-item"
        :class="{
         'active-menu-item': $route.path == '/my-dashboard',
        }"
       >
        Dashboard Analytics
       </div>

       <div
        @click="goToLink('/dashboard-analytics')"
        v-if="selectedMarketType == 'equity' && !isAdmin"
        class="sub-menu-item"
        :class="{
         'active-menu-item': $route.path == '/my-dashboard',
        }"
       >
        Dashboard Analytics
       </div>

       <div
        @click="selectedMarketType == 'equity' ? goToLink('/past-recommendations') : goToLink('/past-strategy-options')"
        class="sub-menu-item"
        :class="{
         'active-menu-item': $route.path == '/past-recommendations' || $route.path == '/past-strategy-options',
        }"
       >
        <div>My View</div>
       </div>
       <div
        v-if="userProfile && userProfile.mark_as_verified_user"
        @click="goToLink('/my-posts')"
        class="sub-menu-item"
        :class="{
         'active-menu-item': $route.path == '/my-posts',
        }"
       >
        <div>My Posts</div>
       </div>
      </el-collapse-item>
     </el-collapse>

     <div
      class="menu-item"
      v-if="currentUrl.includes('aliceblue.stockants.com') || currentUrl.includes('nuvama.stockants.com')"
      :class="{
       'active-menu-item': $route.path == '/broker-disclaimer',
      }"
      @click="goToLink('/broker-disclaimer')"
     >
      Broker Disclaimer
     </div>

     <div
      class="menu-item"
      v-if="currentUrl.includes('hensex.stockants.com')"
      :class="{
       'active-menu-item': $route.path == '/broker-disclaimer',
      }"
     >
      <a href="https://www.hensexsecurities.com/research-analyst-disclosures-disclaimers/" target="_blank" style="text-decoration: none; color: #606266">Broker Disclaimer</a>
     </div>

     <div class="menu-item" v-if="currentUrl.includes('gcl.stockants.com')">
      <a :href="pdfPath" download="GCL Disclaimer.pdf" style="text-decoration: none; color: #111112" target="_blank">Broker Disclaimer</a>
     </div>

     <div
      class="menu-item"
      :class="{
       'active-menu-item': $route.path == '/expert-buzz',
      }"
      @click="goToLink('/expert-buzz')"
     >
      Expert Buzz
     </div>

     <div
      class="menu-item"
      :class="{
       'active-menu-item': $route.path == '/stockants-compliance',
      }"
      @click="goToLink('/stockants-compliance')"
     >
      StockAnts Compliance
     </div>

     <!-- <div class="menu-item" :class="{
            'active-menu-item':
              $route.path == '/advisors/expert-side/faq',
          }" @click="goToLink('/advisors/expert-side/faq')"
            style="border-bottom: 1px solid #e4e6ec; margin-bottom: 50px;"
          >
            FAQs
          </div> -->

     <div
      v-if="this.userProfile && this.userProfile.profession == 'Retail Investor'"
      class="menu-item"
      :class="{
       'active-menu-item': $route.path == '/retail-side/faq',
      }"
      @click="goToLink('/retail-side/faq')"
      style="border-bottom: 1px solid #e4e6ec; margin-bottom: 50px"
     >
      FAQs
     </div>

     <div
      v-else-if="this.userProfile && this.userProfile.profession == 'Dealer'"
      class="menu-item"
      :class="{
       'active-menu-item': $route.path == 'dealer/faq',
      }"
      @click="goToLink('dealer/faq')"
      style="border-bottom: 1px solid #e4e6ec; margin-bottom: 50px"
     >
      FAQs
     </div>

     <div
      v-else
      class="menu-item"
      :class="{
       'active-menu-item': $route.path == '/advisors/expert-side/faq',
      }"
      @click="goToLink('/advisors/expert-side/faq')"
      style="border-bottom: 1px solid #e4e6ec; margin-bottom: 50px"
     >
      FAQs
     </div>

     <div v-if="paytmSource != 'app' && !currentEnvironment.byPassLogin && currentEnvironment.loginModule != 'BlinkX' && !currentUrl.includes('almondz.stockants.com') && !currentUrl.includes('almondztrade.stockants.com')" class="menu-item" @click="logOut()" style="border-bottom: 1px solid rgb(228, 230, 236); position: fixed; bottom: 0px; width: 220px; background-color: #ffff">Logout</div>
    </div>
   </div>
  </div>

  <div class="main">
   <router-view></router-view>
  </div>

  <div class="professionChangeDialog">
   <el-dialog :visible.sync="changeProfessionDialog" center :modalAppendToBody="false">
    <span>
     Do you want to change your profession from
     <strong>'Retail Investor'</strong>
     to
     <strong>'Market Expert'</strong>
    </span>
    <span slot="footer" class="dialog-footer">
     <el-button class="btn-theme-borderd" @click="changeProfessionDialog = false">Cancel</el-button>

     <el-button class="btn-secondary-theme-borderd" @click="changeProfession()">Confirm</el-button>
    </span>
   </el-dialog>
  </div>
 </div>
</template>

<script>
import { EventBus } from '../eventBus';
import { serverAddr, serverHostName } from '../networkConfig';
import { loginNetworkCallBack } from '../mixins/login.NetworkCallback';
import { updateProfileNetworkCallBack } from '../mixins/UpdateProfile.NetworkCallBack';
import { screenSize } from '../mixins/ScreenSize';
import Hexagon from '@/components/Hexagon.vue';
import { HelperNetworkCallBack } from '../mixins/Helper';

export default {
 name: 'SideNav',

 components: {
  Hexagon,
 },

 mixins: [updateProfileNetworkCallBack, loginNetworkCallBack, screenSize, HelperNetworkCallBack],

 data() {
  return {
   pdfPath: serverHostName + '/Media/important_doc/Stockantscompliancenewgcl.pdf',
   profile_pic: require('../assets/images/navBar/avatar.jpg'),
   toggleSideMenu: '',
   isUserLoggedIn: localStorage.getItem('token') ? true : false,
   changeProfessionDialog: false,
   userProfile: {},
   selectedMarketType: localStorage.getItem('market_type') ? localStorage.getItem('market_type') : 'equity',
   currentUrl: localStorage.getItem('currentUrl') ? localStorage.getItem('currentUrl') : window.location.href,
   websiteUserType: {},
   currentEnvironment: {},
   paytmSource: '',
   isAdmin: false,
  };
 },
 beforeCreate() {
  if (localStorage.getItem('profile')) {
   setTimeout(() => {
    var websiteUserType = localStorage.getItem('websiteUserType') ? JSON.parse(localStorage.getItem('websiteUserType')) : {};
    var userProfile = JSON.parse(localStorage.getItem('profile'));

    var internalTeamList = ['krishaa0801@gmail.com', 'joshiakshay719@gmail.com', 'fegde.mayur@gmail.com', 'snehalvpatil25@gmail.com', 'sumittarkas0001@gmail.com', 'bid.pallavi@gmail.com', 'pallavi.bid@stockants.com', 'bhushanm705811@gmail.com', 'admin@stockants.com', 'sumittarkas001@gmail.com', 'satavchetan08@gmail.com', 'amanm3047@gmail.com'];

    userProfile.email = userProfile.email.toLowerCase();

    if (websiteUserType && websiteUserType.userType == 'stockAnts' && internalTeamList.includes(userProfile.email)) {
     this.isAdmin = true;
    }
   }, 0);
  }
 },

 methods: {
  checkSubscribePlanDetails() {
   this.closeSideBarForMobile();
   if (!Object.keys(this.getSubscribedPlanDetails).length || this.getSubscribedPlanDetails.plan == 'Lite') {
    localStorage.setItem('premiumPlanSubscriptionDialogVisible', true);

    this.$router.push({ path: '/pricing' });
    return;
   }
  },
  checkSelectedSegment() {
   var segmentRoute = this.$route.path;
   if (segmentRoute == '/expert-past-strategy-options') {
    this.selectMarketType('options');
   } else if (segmentRoute == '/experts-past-recommendations') {
    this.selectMarketType('equity');
   }
  },
  goToDashboard() {
   this.$router.push('/');
   this.closeSideBarForMobile();
  },
  selectMarketType(market_type) {
   this.closeSideBarForMobile();

   localStorage.setItem('market_type', market_type);
   this.selectedMarketType = market_type;

   if (this.selectedMarketType == 'options') {
    if (this.$route.path == '/upload-recommendation') {
     this.$router.push('/publish-recommendation-options');
    } else if (this.$route.path == '/past-recommendations') {
     this.$router.push('/past-strategy-options');
    } else {
     this.$router.push('/expert-past-strategy-options');
    }
   } else if (this.selectedMarketType == 'equity') {
    if (this.$route.path == '/publish-recommendation-options') {
     this.$router.push('/upload-recommendation');
    } else if (this.$route.path == '/past-strategy-options') {
     this.$router.push('/past-recommendations');
    } else {
     this.$router.push('/experts-past-recommendations');
    }
   }
  },
  //close side bar on window click
  closeSideBar(e) {
   if (e.target.className == 'activeSideBarBackground' && !this.isDesktop) {
    EventBus.$emit('mobileSideBarIsClosed', false);
    this.closeSideBarForMobile();
    this.toggleSideMenu = '';
   }
  },

  closeSideBarForMobile() {
   document.getElementById('sideBarBackground').setAttribute('class', '');
   document.getElementsByClassName('sideBar')[0].style.left = '-310px';
   document.getElementsByClassName('main')[0].style.width = '100%';
   document.getElementsByClassName('main')[0].style.left = '0px';
   let body = document.getElementsByTagName('body')[0];
   body.style.overflow = 'auto';
  },
  mouseOver() {
   let body = document.getElementsByTagName('body')[0];
   body.style.overflow = 'hidden';
  },
  mouseLeave() {
   let body = document.getElementsByTagName('body')[0];
   body.style.overflow = 'auto';
  },

  goToHomePage(label) {
   if (label == '/dashboard') {
    EventBus.$emit('activeHomePageLink', 'TOP_PERFORMERS'); //event emitted for home page links
   }
  },

  goToLink(link) {
   if (link) {
    this.$router.push(link);
    this.closeSideBarForMobile();
    this.toggleSideMenu = '';
   }
  },
  goToProfile() {
   this.closeSideBarForMobile();
   this.changeProfessionDialog = true;
   if (this.$route.name == 'dashboard') {
    var expertHubSection = document.getElementById('expertHubSection');
    var homePageSideBar = document.getElementById('scroll');
    expertHubSection.style.zIndex = '0';
    homePageSideBar.style.zIndex = '0';
   }
  },
  changeProfession() {
   serverAddr
    .post('/auth/v1/profile', {
     profession: 'Market Expert',
     // profession: "Retail Investor",
     email: this.userProfile.email,
     mobile: this.userProfile.mobile,
    })
    .then(this.updateProfileCallBack)
    .catch(function (error) {
     console.log(error);
    });
  },

  logOut() {
   serverAddr
    .post('/auth/v1/sign_out', {
     refresh_token: localStorage.getItem('refresh_token'),
    })
    .then(this.logoutUserNetworkCallBack)
    .catch(function (error) {
     console.log(error);

     localStorage.clear();
     this.$router.push('/');

     // to set state to it's initial state and clear vue store
     this.$store.commit('resetAllState');
     let body = document.getElementsByTagName('body')[0];
     body.style.overflow = 'auto';
    });
  },

  // stored in store boolean value---to open demo dialog
  openDemoDialog() {
   this.$store.commit('commitDialogVisibility', true);
   this.closeSideBarForMobile();
   this.toggleSideMenu = '';
  },
 },

 mounted() {
  // select user type for navigation access
  if (localStorage.getItem('websiteUserType')) {
   this.websiteUserType = JSON.parse(localStorage.getItem('websiteUserType'));
  }

  if (localStorage.getItem('profile')) {
   this.userProfile = JSON.parse(localStorage.getItem('profile'));
  }

  if (localStorage.getItem('paytmSource')) {
   this.paytmSource = localStorage.getItem('paytmSource');
  }

  if (this.userProfile && this.userProfile.picture) {
   this.profile_pic = serverHostName + this.userProfile.picture;
  }

  // get currentEnvironment details
  if (localStorage.getItem('currentEnvironment')) {
   this.currentEnvironment = JSON.parse(localStorage.getItem('currentEnvironment'));
  }

  EventBus.$on('profilePic', (data) => {
   this.profile_pic = serverHostName + data;
  });

  EventBus.$on('userData', (data) => {
   this.userProfile = data;
  });

  this.checkSelectedSegment();
 },

 computed: {
  //returns stored user profile from local storage
  // userProfile() {
  //   return JSON.parse(localStorage.getItem("profile"));
  // },

  // return user details e.g. accuracy, success rate, rating etc.
  user_details() {
   return this.$store.state.user_details;
  },

  //returns subscribed plan details from local storage
  getSubscribedPlanDetails() {
   return JSON.parse(localStorage.getItem('plan_details'));
  },

  // getSubscribedPlanDetails() {
  //   return this.$store.state.subscribed_plan_details;
  // },

  // return user role from local storage.
  roles() {
   var roles = JSON.parse(localStorage.getItem('roles'));
   return roles[0];
  },

  // show profile card for retail investor if has_recommendation is tru
  checkEligiblity() {
   // this.userProfile.has_recommendation = true;
   if (this.userProfile.has_recommendation == undefined) {
    this.userProfile.has_recommendation = false;
   }
   if (this.userProfile && this.userProfile.profession == 'Retail Investor' && this.userProfile.has_recommendation == false) {
    return false;
   } else {
    return true;
   }
  },
 },

 beforeDestroy() {
  EventBus.$off();
 },
};
</script>

<style lang="scss" scoped>
@import '../css/variable.scss';
@import '../css/common.scss';

.sideBar {
 // background-color: #e53935;
 min-height: 100vh;
 overflow-y: auto;
 width: 260px;
 position: fixed;
 top: 0;
 bottom: 0;
 left: -310px;
 padding: 0;
 transition: all 0.3s ease 0s;
 background: #fff;
 box-shadow: 0 16px 38px -12px rgba(0, 0, 0, 0.56), 0 4px 25px 0 rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2);
 z-index: 3;
}

.profile-section {
 padding: 0 15px;
}

.stockants-logo {
 width: 180px;
 height: 100%;
}

.sideBar-logo-section {
 padding: 10px 5px 0px 5px;
 font-size: 1.5rem;
 color: #fff;
 font-weight: 300;
 line-height: 30px;
 // border-bottom: solid #414550;
 border-width: thin;
}

.sideBar-profile-container {
 margin-top: 10px;
 padding: 5px 5px 10px 5px;
 border-bottom: solid #e4e6ec;
 border-top: solid #e4e6ec;
 border-width: thin;
}

.sideBar-menu-section {
 margin: 0 0 15px;
 padding: 0 0 3px;
 // height: 450px;
 overflow: auto;
}

.go-premium-btn {
 color: #fff;
 background: $secondary-theme-color;
 padding: 5px 8px;
 font-size: 0.6rem;
 border-radius: 6px;
 font-weight: 600;
}

.menu-item {
 cursor: pointer;
 padding: 12px 20px 12px 20px;
 text-decoration: none;
 font-size: 0.8rem;
 color: #111112;
 transition: 0.3s;
 text-decoration: none;
 font-weight: 500;
 border-top: 1px solid #e4e6ec;
}

.active-menu-item {
 color: $secondary-theme-color;
 font-weight: 500;
}

.sub-menu-item {
 padding: 10px 30px 10px 30px;
 cursor: pointer;
}

.sideBar .rank-wrapper {
 position: absolute;
 bottom: -8px;
 right: 0;
 left: 0;
}

.sideBar .more-details-section {
 display: flex;
 justify-content: space-around;
}

/* Position and style the close button (top right corner) */
.sideNav-profile-pic-section {
 // 25255e
 height: 45px;
 min-width: 45px;
 // margin: 0 auto;
 border-radius: 100%;
 // border: 2px solid #df6052;
 background-color: #fff;
 padding: 2px;
 display: inline-block;
}

.sideNav-profile-pic {
 height: 45px;
 width: 45px;
 object-fit: cover;
 border-radius: 100%;
}

.sideNav-profile-name {
 color: #414550;
 font-size: 0.9rem;
 font-weight: 300;
 margin: 0px 0px 0 10px;
}

.SideNav .btn-gradient {
 background-image: linear-gradient(to left, #dc6250, #eb5151);
 margin: 10px 0 30px;
 width: 150px;
 outline: none;
 border-radius: 25px;
 height: 30px;
 color: #fff;
 font-size: 0.9rem;
 border: none;
 cursor: pointer;
}

.SideNav .btn-gradient:hover {
 transition: 0.4s ease;
 box-shadow: 0px 0px 10px -1px #dc6250;
}

.SideNav .publish-btn {
 height: 22px;
 line-height: 5;
 display: flex;
 align-items: center;
 font-weight: 600;

 span {
  line-height: 0;
 }
}

@media screen and (max-width: 700px) {
 // .sideBar-menu-section {
 //   height: 300px;
 // }
}
</style>

<style lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.el-collapse-item__header {
 border: none;
 color: $secondary-theme-color;
 // padding: 0 0 0 15px;
 line-height: unset !important;
 height: auto !important;
}

.el-collapse {
 border: none !important;
}

.sideBar-menu-section::-webkit-scrollbar-track {
 -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
 border-radius: 10px;
 background-color: #f5f5f5;
}

.sideBar-menu-section::-webkit-scrollbar {
 width: 5px;
 background-color: #f5f5f5;
 display: none;
}

.sideBar-menu-section::-webkit-scrollbar-thumb {
 border-radius: 10px;
 -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
 background-color: #777;
 display: none;
}

.el-collapse-item__content {
 padding: 0;
 color: #414550 !important;
 padding-bottom: 0px !important;
}

.el-collapse-item__wrap,
.el-collapse-item,
.el-collapse-item__header {
 background-color: transparent !important;
 border-bottom: none !important;
}

.el-collapse-item__wrap {
 padding: 5px 0 0 0px;
}

.el-collapse-item__arrow {
 color: #414550;
}

.professionChangeDialog {
 .cancel-btn {
  background-color: transparent;
 }

 .el-dialog {
  border-radius: 10px;
  width: 400px;
 }

 .el-dialog--center .el-dialog__body {
  word-break: normal;
 }

 @media screen and (max-width: 420px) {
  .el-dialog {
   width: 90%;
  }
 }
}
</style>
